module.exports = __webpack_public_path__ + "img/611.deda1462.png";